import { Button } from 'components/core';
import { fieldsOf } from 'constants/kpiBuilderCatalogue';
import { RangeBucket } from 'helpers/kpiBuilder/types';
import { BuilderSection } from './BuilderSection';
import { FieldPicker } from './FieldPicker';
import { StepProps } from './StepProps';
import { TextBox } from './TextBox';
import { OUTLINE_SMALL } from './buttonProps';

// Time spent, in milliseconds, in the ranges the live Time-on-Task histograms use.
const MINUTES = [
  ['0-1min', '0', '60000'], ['1-2min', '60000', '120000'], ['2-5min', '120000', '300000'], ['5-10min', '300000', '600000'],
  ['10-20min', '600000', '1200000'], ['20-30min', '1200000', '1800000'], ['30-60min', '1800000', '3600000'], ['60+min', '3600000', ''],
].map(([label, from, to]) => ({ label, from, to }));

// Spread across ranges: pick a number field and describe the ranges.
export const RangesStep = ({ a, patch }: StepProps) => {
  const { rangeField, ranges } = a.custom;
  const save = (next: Partial<typeof a.custom>) => patch({ custom: { ...a.custom, ...next } });
  const setRange = (i: number, next: Partial<RangeBucket>) => save({ ranges: ranges.map((r, j) => (j === i ? { ...r, ...next } : r)) });

  return (
    <>
      <BuilderSection title="Which number do you want to spread?" hint="Pick a number field, such as time spent. Each record is counted in the range its value falls into.">
        <FieldPicker fields={fieldsOf(a.src)} value={rangeField} placeholder="Number field, e.g. totalTimeDuration" onChange={(field) => save({ rangeField: field })} />
      </BuilderSection>
      <BuilderSection title="Ranges" hint="Each range needs a name and a start or an end. The start is included and the end is not, so ranges can sit next to each other.">
        <div className="mb-2">
          <Button {...OUTLINE_SMALL} onClick={() => save({ rangeField: rangeField || 'totalTimeDuration', ranges: MINUTES })}>
            Use time-spent ranges (milliseconds)
          </Button>
        </div>
        {ranges.map((r, i) => (
          <div key={i} className="row g-2 mb-2">
            <div className="col-md-4"><TextBox value={r.label} placeholder="Name, e.g. 1-2min" onChange={(label) => setRange(i, { label })} /></div>
            <div className="col-md-3"><TextBox value={r.from} placeholder="From" onChange={(from) => setRange(i, { from })} /></div>
            <div className="col-md-3"><TextBox value={r.to} placeholder="To" onChange={(to) => setRange(i, { to })} /></div>
            <div className="col-md-2">
              <Button {...OUTLINE_SMALL} onClick={() => save({ ranges: ranges.filter((_, j) => j !== i) })}>
                Remove
              </Button>
            </div>
          </div>
        ))}
        <Button {...OUTLINE_SMALL} onClick={() => save({ ranges: [...ranges, { label: '', from: '', to: '' }] })}>
          Add a range
        </Button>
      </BuilderSection>
    </>
  );
};
